import React from "react";

import { Input } from "./styles";

interface DateFieldProps {
    // Строка "ГГГГ-ММ-ДД" — формат нативного input[type=date]. Даты в контракте лежат
    // числами, поэтому конвертацию делает фича (shared/lib/dateInput).
    value: string;
    onChange: (value: string) => void;
    min?: string;
    max?: string;
    disabled?: boolean;
    id?: string;
    className?: string;
}

export const DateField = ({
    value,
    onChange,
    min,
    max,
    disabled,
    id,
    className,
}: DateFieldProps) => (
    <Input
        id={id}
        className={className}
        type="date"
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
    />
);
